export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-telephone-accessible-d876d781a924711505ddb98ef85ce37b.svg";